// extracted by mini-css-extract-plugin
export default {"card":"_4r6ZqKEP","mobile":"mobile","wrapper":"jQCMPlZf","body":"erjL1z2f","date":"yPONWSHr","firstAnnounce":"DFf7zd9z"};